//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseBuilder.js";
import "../AME/AME.SelectAMEBaseNode.js";
import "../no/SelectObject.js";
import "../no/Tooling.js";
let d=[[[0,"ImportType",1,0],[0,"ReuseLibraryItem",0,"Tooling.SelectReuseLibraryItemBuilder",0],[1,"SelectedEclassNode",0,"AME.SelectAMEBaseNode",0]],[[[],"MapEClassObjectToADLibraryObject",{},0,0],[[],"UnMapEClassObject",{},0,0],[["selectedEClassProperty","selectedADPropertyId","selectedADPropertyName"],"MapEClassPropertyToADLibraryObjectProperty",{},3,0],[["selectedEClassProperty"],"UnMapEClassPropertyToADLibraryObjectProperty",{},1,0],[["selectedEClassPropertyId","selectedEClassPropValueId","selectedADLibraryObjectPropValueName"],"MapEClassPropValueToADLibraryObjectPropValue",{},3,0],[["selectedEClassPropId","selectedEclassPropValueId"],"UnMapEClassPropertyValue",{},2,0],[["adPropId","adDefaultValue"],"SetAdPropertyIdToDefaultValueMap",{},2,0],[[],"TransferGroupMappingToClass",{},0,0]],[]];
SPLM.AME.ManageEclassMappingBuilder = class extends SPLM.AME.AMEBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ManageEclassMappingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.ImportType = Object.freeze({
    "AddType" : "AddType", "AddFunction" : "AddFunction", "AddChildren" : "AddChildren"});

export default SPLM;